import ClientHoverBox, { getParentClients } from "../clients/client_hover_box";
import React, { FC, memo } from "react";

// import { AvatarImage } from "./avatar";

import { ClientModule } from "../../redux";
import MoreDetailsButton from "./buttons/more-details-button";
import styled from "../../theme";
import EditSvgIcon from "../../assets/icons/pencil_black.svg";

const Heading = styled.div`
    color: #4a4a4a;
    font-size: 20px;
    display: flex;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    min-width: 0;
    align-items: center;

    & .actions__container {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    & .actions__container--inline {
        margin-left: 8px;
    }
`;

const DetailsContainer = styled.div`
    position: sticky;
    top: 0;
    display: flex;
    font-size: 14px;
    // padding: 5px 0;
    // margin-bottom: 5px;
    // background-color: #fff;
    z-index: 99;
    width: 100%;
    min-width: 0;
`;

const EditIconContainer = styled.button<{ $isInline?: boolean }>`
    cursor: pointer;
    width: ${(props) => (props.$isInline ? '24px' : '28px')};
    height: ${(props) => (props.$isInline ? '24px' : '28px')};
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    border-radius: 6px;
    padding: 0;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: #eef2f6;
    }

    &:hover svg path {
        stroke: #334155;
    }
`;
const StyledEditIcon = styled(EditSvgIcon)`
    width: 16px;
    height: 16px;
    path {
        transition: stroke 0.15s ease;
    }
`;

const DetailsBox = styled.div`
    width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    min-width: 0;
`;

// const Avatar = styled(AvatarImage)`
// `;

const NameSeperator = styled.span`
    font-size: 24px;
    color: #9e999f;
    padding: 0 1px;
`;

const Name = styled.a`
    color: #222222;
    font-size: 18px;
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        color: #41a1dc;
    }
`;

const VerticalCenterContainer = styled.div`
    display: flex;
    align-items: center;
    margin-right: 24px;
    min-width: 0;
    flex: 1 1 auto;
`;
// const VerticalBorderImage = styled.div`
//     border-left: 2px solid #E2E2E2;
//     height: 58px;
//     margin-left: 30px;
//     margin-right: 24px;
// `;
const VerticalBorder = styled.div`
    border-left: 1px solid #E2E2E2;
    height: 22px;
    margin: 0;
`;

export interface BasicDetailInfo {
    id: number;
    displayName: string;
    avatarId?: string;
    firstName?: string;
    lastName?: string;
    parent?: ClientModule.BasicClientInfo;
}

export interface DetailsProps {
    info: BasicDetailInfo;
    detailsDisplayed: boolean;
    onToggleDetails(): void;
    onGoBack(): void;
    onAncestorClick?(id: number): void;
    onClick?(id: number): void;
    actionsInline?: boolean;
}

const BasicDetail: FC<DetailsProps> = memo((props) => {
    const renderActions = (isInline: boolean) => (
        <div className={`actions__container${isInline ? " actions__container--inline" : ""}`}>
            <MoreDetailsButton
                isDetailsDisplayed={props.detailsDisplayed}
                onToggleClientDetails={props.onToggleDetails}
                isInline={isInline}
            />
            {!isInline && <VerticalBorder />}
            <EditIconContainer
                type="button"
                $isInline={isInline}
                onClick={() => props.onClick && props.onClick(props.info.id)}
            >
                <StyledEditIcon />
            </EditIconContainer>
        </div>
    );

    return (
        <DetailsContainer>
            {/* <Avatar
                avatarId={props.info.avatarId}
                firstName={props.info.firstName}
                lastName={props.info.lastName}
                width={52}
                height={52}
                fontSize={24}
            />
            <VerticalBorderImage /> */}
            <DetailsBox>
                <Heading>
                    <VerticalCenterContainer>
                        {props.info.parent &&
                            getParentClients(props.info.parent).map(
                                (ancestorClient) => (
                                    <>
                                        <ClientHoverBox
                                            key={ancestorClient.id}
                                            client={ancestorClient}
                                            onClick={props.onAncestorClick}
                                        />
                                        <NameSeperator>|</NameSeperator>
                                    </>
                                )
                            )}
                        <Name>{`${props.info.displayName}`}</Name>
                        {props.actionsInline && renderActions(true)}
                    </VerticalCenterContainer>
                    {!props.actionsInline && renderActions(false)}
                </Heading>
            </DetailsBox>
        </DetailsContainer>
    );
});

export default BasicDetail;
